import { render } from "./TableColumnPlusAfter.vue?vue&type=template&id=0eb11c7a"
import script from "./TableColumnPlusAfter.vue?vue&type=script&lang=js"
export * from "./TableColumnPlusAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableColumnPlusAfter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0eb11c7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0eb11c7a', __exports__)) {
    api.reload('0eb11c7a', __exports__)
  }
  
  module.hot.accept("./TableColumnPlusAfter.vue?vue&type=template&id=0eb11c7a", () => {
    api.rerender('0eb11c7a', render)
  })

}


export default __exports__